<template>
  <div class="p-4">
    <button @click="openNewOutletDialog" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded">
      New Outlet
    </button>
    <el-table
      :empty-text="'No Outlets available'"
      :data="outlets.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name"
        sortable>
      </el-table-column>
      <el-table-column
        prop="p_code"
        label="Code/Identifier"
        sortable>
      </el-table-column>
      <el-table-column
        label="Address"
        sortable>
        <template slot-scope="scope">{{scope.row.address}} {{scope.row.city ? scope.row.city : ''}}, {{scope.row.state ? scope.row.state.name : ''}}, {{scope.row.country ? scope.row.country.name : ''}}</template>
      </el-table-column>
      <el-table-column
        label="Orders" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.order_count > 0"><el-tag size="small" type="info">{{scope.row.order_count}}</el-tag></span>
          <span v-else><el-tag size="small" type="info">0</el-tag></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="Enabled">
        <template slot-scope="scope">
          <span v-if="scope.row.status === true"><el-tag size="small" type="success">Yes</el-tag></span>
          <span v-else><el-tag size="small" type="danger">No</el-tag></span>
        </template>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot="header">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Type to search"/>
        </template>
        <template slot-scope="scope">
          <el-button @click="viewOutlet(scope.row.id)" type="text" size="small">
            <i class="text-xl text-gray-500 el-icon-view mr-1"></i>
          </el-button>
          <el-button @click="updateOutlet(scope.row)" type="text" size="small">
            <i class="text-xl el-icon-edit-outline mr-4"></i>
          </el-button>
          <el-button @click="deleteOutlet(scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <OutletUpdateForm :upload_url="upload_url" />
    <NewOutletForm />
  </div>
</template>

<script>

import { flatMap } from 'lodash';
import NewOutletForm from './_includes/NewOutletForm.vue';
import OutletUpdateForm from './_includes/OutletUpdateForm.vue';

export default {
  name: 'Outlets',
  components: {
    OutletUpdateForm,
    NewOutletForm,
  },
  data() {
    return {
      search: '',
      upload_url: null,
    };
  },
  computed: {
    outlets() {
      return flatMap(this.$store.state.OutletModule.outlets);
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    openNewOutletDialog() {
      this.$modal.show('new-outlet-modal');
    },
    viewOutlet(id) {
      this.$router.push(`/ecommerce/outlets/${id}/details`);
    },
    updateOutlet(outlet) {
      this.upload_url = `${process.env.VUE_APP_ECOMMERCE_BASE_API}/merchant/catalog/${outlet.id}/images?type=outlets`;
      this.$store.commit('OutletModule/setProperty', { property: 'outlet', payload: outlet });
      this.$modal.show('update-outlet-modal');
    },
    deleteOutlet(outletId) {
      this.$confirm('Are you sure you want to delete this outlet?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('OutletModule/deleteOutlet', { outletId });
          this.$notify.success({
            title: 'Success',
            message: 'Outlet has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
